import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import routes from './routers'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import fHeader from './components/f-header'
import fFooter from './components/f-footer'
import axios from 'axios'
import store from './store'
import 'github-markdown-css/github-markdown.css'
import hljs from 'highlight.js'
import './assets/css/bootstrap.min.css'
import VueTyperPlugin from 'vue-typer'


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.component("f-header", fHeader)
Vue.component("f-footer", fFooter)
Vue.use(VueTyperPlugin)

if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = "//localhost:5000"
}

// 如果开启了typescript 需要额外安装 npm install @types/highlight.js
// 通过 import * as hljs from 'highlight.js' 引入
Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('pre code')
  blocks.forEach(block => {
    hljs.highlightBlock(block)
  })
})

const router = new VueRouter({
  base: '/SunBlog',
  routes,
  mode: 'hash'
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
